import { type ReactNode, useId } from "react";

import { cn } from "@/shared/lib";
import { RefreshBar, RefreshLabel } from "@/shared/ui/refresh";

type FriendsSectionProps = {
  title: ReactNode;
  // Подпись под заголовком.
  description?: ReactNode;
  // Справа от заголовка: переключатели.
  aside?: ReactNode;
  id?: string;
  className?: string;
  // Данные блока перечитываются (смена периода): бегущая полоса и «обновляем».
  refreshing?: boolean;
  children: ReactNode;
};

// Карточка блока экрана «Друзья»: заголовок, подпись и содержимое.
export const FriendsSection = ({
  title,
  description,
  aside,
  id,
  className,
  refreshing = false,
  children,
}: FriendsSectionProps) => {
  const generatedId = useId();
  const headingId = id ?? generatedId;
  return (
    <section
      aria-labelledby={headingId}
      aria-busy={refreshing || undefined}
      className={cn(
        "relative flex min-w-0 flex-col gap-3.5 rounded-xl border border-border bg-surface p-5",
        className,
      )}
    >
      <RefreshBar active={refreshing} />
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <div className="flex flex-col gap-0.5">
          <h2 id={headingId} className="scroll-mt-6 font-display text-[26px] leading-tight">
            {title}
          </h2>
          {description !== undefined && <p className="text-sm text-muted">{description}</p>}
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <RefreshLabel active={refreshing} />
          {aside}
        </div>
      </div>
      {children}
    </section>
  );
};
